<template>
  <div class="app-layout">
    <!-- Sidebar -->
    <AppSidebar v-if="showSidebar" :is-mobile-open="isMobileSidebarOpen" @close="isMobileSidebarOpen = false" />

    <!-- Overlay pour mobile -->
    <div
      v-if="isMobileSidebarOpen"
      class="sidebar-overlay"
      @click="isMobileSidebarOpen = false"
    />

    <!-- Contenu principal -->
    <div class="main-content" :class="{ 'sidebar-open': isMobileSidebarOpen }">
      <!-- Header -->
      <AppHeader @toggle-sidebar="isMobileSidebarOpen = !isMobileSidebarOpen" />

      <!-- Contenu de la page -->
      <main class="page-content">
        <RouterView v-slot="{ Component, route }">
          <Transition name="page" mode="out-in">
            <component :is="Component" :key="route.path" />
          </Transition>
        </RouterView>
      </main>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useRoute } from 'vue-router'
import AppSidebar from '@/components/layout/AppSidebar.vue'
import AppHeader from '@/components/layout/AppHeader.vue'

const route = useRoute()
const isMobileSidebarOpen = ref(false)

// Masquer la sidebar sur certaines pages (ex: login)
const showSidebar = computed(() => {
  return route.meta.layout !== 'auth'
})

// Gérer la fermeture de la sidebar sur mobile lors du redimensionnement
const handleResize = () => {
  if (window.innerWidth >= 1024) {
    isMobileSidebarOpen.value = false
  }
}

onMounted(() => {
  window.addEventListener('resize', handleResize)
})

onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
})
</script>

<style scoped>
.app-layout {
  @apply flex min-h-screen bg-gray-50;
}

.sidebar-overlay {
  @apply fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden;
  transition: opacity 0.3s ease-in-out;
}

.main-content {
  @apply flex-1 flex flex-col transition-all duration-300;
  margin-left: 0;
  width: 100%;

  @media (min-width: 1024px) {
    margin-left: 280px;
    width: calc(100% - 280px);
  }
}

.main-content.sidebar-open {
  @apply lg:ml-0;
}

.page-content {
  @apply flex-1 p-4 lg:p-6;
}

/* Transitions de page */
.page-enter-active,
.page-leave-active {
  transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out;
}

.page-enter-from {
  opacity: 0;
  transform: translateY(10px);
}

.page-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>

